import { Component } from '@angular/core';

@Component({
  selector: 'sw-section-two',
  templateUrl: './section-two.component.html',
})
export class SectionTwoComponent {

}
